import { v4 as uuidv4 } from 'uuid';

export default class BackgroundThemeImageMultipleInputData {
    id = uuidv4()
    x = null
    y = null
    bounding_x = null
    bounding_y = null
    width = null
    height = null
    angle = null
    scaleX = null
    scaleY = null
    url = null

    constructor(url, data = {}) {
        this.url = url
        this.setData(data)
    }

    setData(data) {
        [
            'x',
            'y',
            'bounding_x',
            'bounding_y',
            'width',
            'height',
            'angle',
            'scaleX',
            'scaleY',
            'id',
            'url'
        ].forEach((key) => {
            this[key] = data?.[key] !== undefined ? data[key] : this[key]
        })
    }

    getUrl(defVal = '') {
        return this.url || defVal
    }

    getId() {
        return this.id
    }

    get(key, defaultValue = null) {
        return this[key] || defaultValue
    }

    _toString() {
        return JSON.stringify(this)
    }
}